import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";

import Icon from "../custom-widgets/icon";
import { useLanguageContext } from "../../contexts/language-context";

/**
 * This renders the mobile menu above section, where you can search, go to locations/ATMs and switch the language.
 *
 * @param {Object} props - The object containing props.
 * @param {string} props.altUrl - used when we click the button to switch the language.
 * @param {Function} props.setShowMobileSearch - required function to show the search suggestions section within the mobile menu.
 * @returns {React.JSX.Element} Returns the JSX component to render
 */
const MobileMenusSectionAboveMenus = ({ altUrl = "", setShowMobileSearch = () => {} }) => {
  const isSpanish = useLanguageContext();

  return (
    <div className="position-sticky">
      <div className="bg-white d-flex align-content-center justify-content-between border-bottom">
        <div className="w-100 p-3">
          {isSpanish ? (
            <div className="w-100 d-flex align-items-center justify-content-between">
              <button
                id="mm-activate-search-modal"
                onClick={() => setShowMobileSearch(true)}
                className="btn-anchor-link"
              >
                <Icon lib="fal" name="search" />
              </button>
              <div className="d-flex align-items-center">
                <Icon class="text-primary mr-1" name="map-marker-alt" />
                <Link to="/es/sucursales" id="mm-es-locations-link">
                  Sucursales
                </Link>{" "}
                |{" "}
                <Link to="/locations/atm" id="mm-atms-link">
                  ATMs
                </Link>
              </div>
              <div className="text-nowrap">
                <Icon lib="far" name="globe" class="text-primary mr-1" />
                <Link to={altUrl} id="mm-english-link">
                  English
                </Link>
              </div>
            </div>
          ) : (
            <div className="w-100 d-flex align-items-center justify-content-between">
              <button
                id="mm-activate-search-modal"
                onClick={() => setShowMobileSearch(true)}
                className="btn-anchor-link"
              >
                <Icon lib="fal" name="search" />
              </button>
              <div className="d-flex align-items-center">
                <Icon lib="far" name="map-marker-alt" class="text-primary mr-1" />
                <Link to="/locations" id="mm-en-locations-link">
                  Locations
                </Link>{" "}
                |{" "}
                <Link to="/locations/atm" id="mm-atms-link">
                  ATMs
                </Link>
              </div>
              <div className="text-nowrap">
                <Icon lib="far" name="globe" class="text-primary mr-1" />
                <Link to={altUrl} id="mm-spanish-link">
                  Español
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileMenusSectionAboveMenus;

MobileMenusSectionAboveMenus.propTypes = {
  altUrl: PropTypes.string.isRequired,
  setShowMobileSearch: PropTypes.func.isRequired
};
